import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=2ec0cbda&scoped=true&"
import script from "./Logo.vue?vue&type=script&setup=true&lang=ts&"
export * from "./Logo.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./Logo.vue?vue&type=style&index=0&id=2ec0cbda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec0cbda",
  null
  
)

export default component.exports